import React from 'react';
import {
  TableBody,
  Paper,
  Typography,
  TableContainer,
  Table,
  Box,
  TableRow,
  TableCell,
} from '@mui/material';
import PaymentListHead from './PaymentListHead';
import PaymentListRow from './PaymentListRow';
import {PaymentListOrderBy} from '../constant';
import {PaymentInfo} from '../types';
import '../style.scss';

interface PaymentListTableProps {
  isLoading: boolean;
  isError: boolean;
  message: string;
  payments: PaymentInfo[];
  sortActiveColumn?: PaymentListOrderBy;
  sortDirection?: boolean;
  status?: string;
  setSortActiveColumn: (value?: PaymentListOrderBy) => void;
  setSortDirection: React.Dispatch<React.SetStateAction<boolean>>;
  setStatus?: (value: string) => void;
  onSort?: (column: PaymentListOrderBy) => void;
}

const ErrorState: React.FC<{message: string}> = ({message}) => (
  <Box className="payment-list-error">
    <Typography color="error">{message}</Typography>
  </Box>
);

const EmptyState: React.FC = () => (
  <TableRow>
    <TableCell colSpan={6}>
      <Box className="payment-list-empty">
        <Typography>No payments found</Typography>
      </Box>
    </TableCell>
  </TableRow>
);

const LoadingTableBody: React.FC = () => (
  <TableBody>
    {Array.from({length: 10}, (_, index) => (
      <TableRow key={`loading-row-${index}`}>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
        <TableCell className="payment-list-cell">
          <Box className="payment-list-loading-skeleton" />
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const PaymentListTable: React.FC<PaymentListTableProps> = ({
  isLoading,
  isError,
  message,
  payments,
  sortActiveColumn,
  sortDirection,
  setSortActiveColumn,
  setSortDirection,
  onSort,
}) => {
  if (isError) {
    return <ErrorState message={message} />;
  }

  return (
    <div className="flex-1 flex flex-col overflow-auto">
      <TableContainer component={Paper} className="payment-list-table">
        <Table stickyHeader aria-label="simple table" className="max-h-full">
          <PaymentListHead
            isLoading={isLoading}
            sortActiveColumn={sortActiveColumn}
            sortDirection={sortDirection}
            setSortActiveColumn={setSortActiveColumn}
            setSortDirection={setSortDirection}
            onSort={onSort}
          />
          {isLoading ? (
            <LoadingTableBody />
          ) : (
            <TableBody>
              {payments.length ? (
                <>
                  {payments.map(payment => (
                    <PaymentListRow key={payment.id} payment={payment} />
                  ))}
                </>
              ) : (
                <EmptyState />
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

export default PaymentListTable;
